import { StackGrid } from "@data-display/layout/StackGrid";
import { Button } from "@mui/material";
import clsx from "clsx";
import { type ReactNode, useMemo } from "react";
import { useDRPContext } from "../../context";
import { useDRMPContext } from "./context";
import { DRMPMonthItemContainer, monthItemClasses } from "./styles";
import type { IDRMPMonth, IDRMPMonthItem } from "./types";

const DRMPMonthItem = ({ date }: IDRMPMonthItem) => {
  const { minDate, maxDate, endDateDisabled, timeZone } = useDRPContext();
  const { handleMouseEnter, handleMouseLeave, handleSelect, isSelected, isBetween, selectRange } = useDRMPContext();

  const selected = isSelected(date);
  const between = selected === "false" && isBetween(date);
  const disabled = (minDate && date < minDate) || (maxDate && date > maxDate);

  return (
    <DRMPMonthItemContainer
      className={clsx(monthItemClasses.root, {
        [monthItemClasses.divStartSelected]: selected === "start" && selectRange.endDate,
        [monthItemClasses.divEndSelected]: selected === "end" && selectRange.startDate,
        [monthItemClasses.between]: between && selected === "false",
      })}
    >
      <Button
        className={clsx(monthItemClasses.button, {
          [monthItemClasses.selected]: selected !== "false",
        })}
        onMouseEnter={() => handleMouseEnter(date)}
        onMouseLeave={handleMouseLeave}
        onClick={() => handleSelect(date, endDateDisabled)}
        disabled={disabled}
      >
        {date.toLocaleDateString("fr-FR", { month: "short", timeZone })}
      </Button>
    </DRMPMonthItemContainer>
  );
};

export const DRMPMonth = ({ index }: IDRMPMonth) => {
  const { yearRange } = useDRMPContext();

  const items = useMemo(() => {
    const items: ReactNode[] = [];
    for (let i = 0; i < 12; i++) {
      items.push(<DRMPMonthItem key={i} date={new Date(yearRange[index], i)} />);
    }
    return items;
  }, [index, yearRange]);

  return (
    <StackGrid perLine={4} rowGap={0.5} boxSizing="border-box">
      {items}
    </StackGrid>
  );
};
